import script from "./SubscribePlanItemHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribePlanItemHeader.vue?vue&type=script&setup=true&lang=js"

import "./SubscribePlanItemHeader.vue?vue&type=style&index=0&id=568ae1d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-568ae1d8"]])

export default __exports__